// ─────────────────────────────────────────────
// src/styles/tokens.js
// Brand design tokens — import anywhere in JS/JSX
// ─────────────────────────────────────────────

export const COLORS = {
  // Brand
  magenta:  '#fe34e8',
  violet:   '#5f08e7',
  navy:     '#0b0e86',
  white:    '#ffffff',
  lavender: '#785e98',
  black:    '#000000',
  electric: '#080cef',

  // Surfaces
  bg:       '#04040f',
  surface1: '#0a0a1a',
  surface2: '#0f0f24',
  surface3: '#141430',

  // Semantic
  success: '#00d084',
  warning: '#f59e0b',
  danger:  '#ef4444',
  info:    '#3b82f6',

  // Text
  textMuted:  'rgba(255,255,255,0.45)',
  textSubtle: 'rgba(255,255,255,0.25)',
};

export const GRADIENTS = {
  primary: `linear-gradient(135deg, ${COLORS.magenta}, ${COLORS.violet})`,
  blue:    `linear-gradient(135deg, ${COLORS.violet}, ${COLORS.electric})`,
  warm:    `linear-gradient(135deg, ${COLORS.magenta}, ${COLORS.lavender})`,
  hero:    `radial-gradient(ellipse 80% 60% at 65% 40%, ${COLORS.navy}70 0%, transparent 60%)`,
};

export const SHADOWS = {
  glow:  `0 0 40px rgba(254, 52, 232, 0.25)`,
  card:  `0 4px 24px rgba(0, 0, 0, 0.4)`,
  hover: `0 20px 60px rgba(95, 8, 231, 0.25)`,
  mgGlow: `0 0 20px rgba(254,52,232,0.5)`,
};

export const STATUS_COLORS = {
  Applied:   '#3b82f6',
  Reviewing: '#f59e0b',
  Interview: '#5f08e7',
  Offer:     '#00d084',
  Rejected:  '#ef4444',
  Pending:   '#f59e0b',
  Live:      '#00d084',
  Closed:    '#ef4444',
};

export const TYPE_COLORS = {
  Featured: '#fe34e8',
  Urgent:   '#ef4444',
  New:      '#00d084',
};

// Shorthand alias
export const C = COLORS;
export const G = GRADIENTS;
export const S = SHADOWS;
